_ = require('lodash')
moment = require("moment")

class PeriodFilterCtrl
  constructor: (@$scope, @$filter) ->
    @user_id = @$scope.userInfo?.user_id
    startDate = localStorage.getItem("#{@user_id}_FILTER_PERIOD_START_DATE")
    endDate = localStorage.getItem("#{@user_id}_FILTER_PERIOD_END_DATE")
    @startDate = if startDate? then moment(startDate) else moment().subtract(10, 'years')
    @endDate = if endDate? then moment(endDate) else moment().endOf('year')
    label = localStorage.getItem("#{@user_id}_FILTER_PERIOD_SELECTED_LABEL")
    if label == @$filter('translate')('_ANALYSIS.PERIOD_FILTER.ENTIRE_PERIOD')
      @endDate = moment().endOf('year')

    @$scope.$watch (=> @startDate + @endDate), @_publishChange

    roundType = localStorage.getItem("#{@user_id}_FILTER_roundType")
    @$scope.roundType = if roundType? then JSON.parse(roundType) else [1, 1.5]

    @$scope.isInclude15 = JSON.parse(localStorage.getItem("#{@user_id}_FILTER_isInclude15"))
    @$scope.isInclude05 = JSON.parse(localStorage.getItem("#{@user_id}_FILTER_isInclude05"))

    unless @$scope.isInclude15?
      @$scope.isInclude15 = true
      localStorage.setItem "#{@user_id}_FILTER_isInclude15", JSON.stringify(true)

    unless @$scope.isInclude05?
      @$scope.isInclude05 = false
      @$scope.roundType = _.filter(@$scope.roundType, (type) -> type != 0.5)
      localStorage.setItem "#{@user_id}_FILTER_isInclude05", JSON.stringify(false)

    @handleRoundType15()
    @handleRoundType05()

    @$scope.clickInclude15 = (isInclude15) =>
      @$scope.isInclude15 = isInclude15
      localStorage.setItem "#{@user_id}_FILTER_isInclude15", JSON.stringify(isInclude15)
      @handleRoundType15()
      @$scope.$parent.$emit "roundTypeUpdated.gnp.dashboard", @$scope.roundType.sort()
      localStorage.setItem "#{@user_id}_FILTER_roundType", JSON.stringify(@$scope.roundType.sort())

    @$scope.clickInclude05 = (isInclude05) =>
      @$scope.isInclude05 = isInclude05
      localStorage.setItem "#{@user_id}_FILTER_isInclude05", JSON.stringify(isInclude05)
      @handleRoundType05()
      @$scope.$parent.$emit "roundTypeUpdated.gnp.dashboard", @$scope.roundType.sort()
      localStorage.setItem "#{@user_id}_FILTER_roundType", JSON.stringify(@$scope.roundType.sort())

  handleRoundType15: ->
    if @$scope.isInclude15
      if 1.5 not in @$scope.roundType
        @$scope.roundType.push(1.5)
    else
      @$scope.roundType = _.filter(@$scope.roundType, (type) -> type != 1.5)

  handleRoundType05: ->
    if @$scope.isInclude05
      if 0.5 not in @$scope.roundType
        @$scope.roundType.push(0.5)
    else
      @$scope.roundType = _.filter(@$scope.roundType, (type) -> type != 0.5)

  _publishChange: =>
    localStorage.setItem "#{@user_id}_FILTER_PERIOD_START_DATE", @startDate
    localStorage.setItem "#{@user_id}_FILTER_PERIOD_END_DATE", @endDate
    @$scope.$parent.$emit "periodSelected.gnp.dashboard", @startDate, @endDate, @$scope.roundType.sort()


PeriodFilterCtrl.$inject = [
  '$scope'
  '$filter'
]

module.exports = PeriodFilterCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/period-filter/period-filter-controller.coffee